module.exports = __webpack_public_path__ + "static/media/odaiba-bridge.ef6e327a.jpg";